module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "contents",
    attrs: {
      "id": "contents"
    }
  }, [_c('em', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('em', [_vm._v("Chapter 1")]), _vm._v(" IN ONE PIECE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_c('em', [_vm._v("Chapter 2")]), _vm._v(" ROTTEN APPLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_c('em', [_vm._v("Chapter 3")]), _vm._v(" THE WRONG KIND OF ILL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04"
    }
  }, [_c('em', [_vm._v("Chapter 4")]), _vm._v(" WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 5")]), _vm._v(" SWALLOWED MARBLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 6")]), _vm._v(" SCISSORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 7")]), _vm._v(" A LATE CALLER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 8")]), _vm._v(" THE MIDNIGHT POST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 9")]), _vm._v(" A STITCH IN TIME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 10")]), _vm._v(" ABSENT WITHOUT LEAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 11")]), _vm._v(" THE ARCHITECT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 12")]), _vm._v(" MONSTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 13")]), _vm._v(" THE BRINK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 14")]), _vm._v(" SILENT TREATMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 15")]), _vm._v(" AMBUSH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 16")]), _vm._v(" CAUGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 17")]), _vm._v(" QUIET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 18")]), _vm._v(" EGGSHELLS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 19")]), _vm._v(" RUNNING FROM THE SCISSOR MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 20")]), _vm._v(" FROSTY WELCOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 21")]), _vm._v(" CANNED CHEESE AND BANANAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 22")]), _vm._v(" THE UNDERBELLY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 23")]), _vm._v(" SHIFTS AND SHIMMERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 24")]), _vm._v(" THE SHRIKE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 25")]), _vm._v(" THE PACT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 26")]), _vm._v(" A SURPLUS GIRL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 27")]), _vm._v(" THE TRUE COLORS OF VIOLET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 28")]), _vm._v(" A WINTER’S TALE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 29")]), _vm._v(" TRISTA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 30")]), _vm._v(" WASTE, WITHER, WANT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 31")]), _vm._v(" ECHOES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 32")]), _vm._v(" SPITTING IT OUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 33")]), _vm._v(" THE TRAM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 34")]), _vm._v(" A GAPING HOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 35")]), _vm._v(" CRUEL MIRROR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 36")]), _vm._v(" HUE AND CRY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 37")]), _vm._v(" STORMS AND TEACUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 38")]), _vm._v(" GREEN BOTTLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 39")]), _vm._v(" A SHEEP IN WOLF’S CLOTHING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 40")]), _vm._v(" MIDNIGHT RIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 41")]), _vm._v(" FIND THE LADY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 42")]), _vm._v(" TIME RUNS OUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 43")]), _vm._v(" LETTING GO")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0